import { useMutation, useQueryClient } from '@tanstack/react-query'
import { learnerDiagnosticsApi } from '@/api/learnerDiagnostics'
import { pendingDiagnosticKey } from './usePendingDiagnostic'

export function useCompleteDiagnosticAiq() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const res = await learnerDiagnosticsApi.completeAiq()
      return res.data.data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: pendingDiagnosticKey }),
  })
}

export function useAcknowledgeDiagnostic() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      const res = await learnerDiagnosticsApi.acknowledge()
      return res.data.data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: pendingDiagnosticKey }),
  })
}
